export default __webpack_public_path__ + "static/media/Compute_SPICE.afd652b8.svg";